// SALES-402 会員限定ページモーダル表示用スクリプト 新規作成

(() => {
  const initMemberCartModal = () => {
    console.log("[member-cart-modal] init");

    const modal = document.querySelector("[data-member-cart-modal]");
    if (!modal) {
      console.warn("[member-cart-modal] modal not found");
      return;
    }

    const input = modal.querySelector("[data-member-number-input]");
    const confirmButton = modal.querySelector("[data-member-add-confirm]");
    const cancelButtons = modal.querySelectorAll("[data-member-cancel]");

    if (!input || !confirmButton) {
      console.warn("[member-cart-modal] input or confirm button not found");
      return;
    }

    let pendingForm = null;
    let pendingSubmitter = null;

    const propertySelector = "[data-member-number-property]";
    const memberNumberLength = 6;

    const openModal = (form, submitter) => {
      console.log("[member-cart-modal] open");

      pendingForm = form;
      pendingSubmitter = submitter;

      input.value = "";
      confirmButton.disabled = true;
      modal.hidden = false;

      requestAnimationFrame(() => {
        input.focus();
      });
    };

    const closeModal = () => {
      modal.hidden = true;
      pendingForm = null;
      pendingSubmitter = null;
      input.value = "";
      confirmButton.disabled = true;
    };

    const shouldOpenModal = (form) => {
      if (!(form instanceof HTMLFormElement)) return false;
      if (!form.querySelector(propertySelector)) return false;
      if (form.dataset.memberPopupConfirmed === "true") return false;

      return true;
    };

    const intercept = (event, form, submitter) => {
      if (!shouldOpenModal(form)) return;

      console.log("[member-cart-modal] intercepted");

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openModal(form, submitter);
    };

    document.addEventListener(
      "click",
      (event) => {
        const submitter = event.target.closest("#addToCart, .js-ajax-submit");
        if (!submitter) return;

        const form = submitter.closest("form");
        intercept(event, form, submitter);
      },
      true
    );

    document.addEventListener(
      "submit",
      (event) => {
        const form = event.target;
        intercept(event, form, event.submitter);
      },
      true
    );

    input.addEventListener("input", () => {
      input.value = input.value.replace(/[^0-9]/g, "").slice(0, memberNumberLength);
      confirmButton.disabled = input.value.length < memberNumberLength;
    });

    confirmButton.addEventListener("click", () => {
      if (!pendingForm) return;

      const memberNumber = input.value.trim();
      if (memberNumber.length !== memberNumberLength) return;

      const memberPropertyInput = pendingForm.querySelector(propertySelector);
      if (!memberPropertyInput) return;

      memberPropertyInput.value = memberNumber;

      const form = pendingForm;
      const submitter = pendingSubmitter;

      form.dataset.memberPopupConfirmed = "true";

      closeModal();

      if (
        submitter &&
        submitter instanceof HTMLElement &&
        submitter.form === form &&
        typeof submitter.click === "function"
        ) {
            submitter.click();

        window.setTimeout(() => {
            delete form.dataset.memberPopupConfirmed;
        }, 1000);

    return;
    }

    if (typeof form.requestSubmit === "function") {
    form.requestSubmit();

    window.setTimeout(() => {
        delete form.dataset.memberPopupConfirmed;
    }, 1000);

    return;
    }

    form.submit();
    });

    cancelButtons.forEach((button) => {
      button.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMemberCartModal);
  } else {
    initMemberCartModal();
  }
})();